import React, { useState, useEffect } from 'react';
import './StockSearch.css';

const StockSearch = () => {
    const [articles, setArticles] = useState([]);
    const [logs, setLogs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [logsLoading, setLogsLoading] = useState(false);
    const [view, setView] = useState('articles'); // 'articles' para la lista de artículos, 'logs' para la vista de logs
    const [selectedArticle, setSelectedArticle] = useState(null);

    // Fetch para los artículos con paginación
    const fetchArticles = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `http://192.168.0.126:5000/articles-paginated?page=${page}&limit=20&name=${encodeURIComponent(searchTerm)}`
            );
            const data = await response.json();
            setArticles(data.articles);
            setTotalPages(data.pages);
        } catch (error) {
            console.error('Error al obtener artículos:', error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch para los logs de un artículo específico
    const fetchLogs = async (articleId) => {
        setLogsLoading(true);
        try {
            const response = await fetch(`http://192.168.0.126:5000/logs/${articleId}`);
            const data = await response.json();
            setLogs(data);
        } catch (error) {
            console.error('Error al obtener logs:', error);
        } finally {
            setLogsLoading(false);
        }
    };

    useEffect(() => {
        if (view === 'articles') {
            fetchArticles();
        }
    }, [page, searchTerm, view]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setPage(1); // Reiniciar a la primera página cuando se realiza una búsqueda
    };

    const goToLogs = (article) => {
        setSelectedArticle(article);
        fetchLogs(article.article_id);
        setView('logs');
    };

    const goToArticles = () => {
        setView('articles');
        setLogs([]);
        setSelectedArticle(null);
    };

    return (
        <div className="stock-search-container">
            <h1 className="title">Aielo - Gestión de Stock</h1>
            {view === 'articles' && (
                <>
                    <div className="search-bar">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Buscar artículos"
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </div>
                    <div className="articles-section">
                        {loading ? (
                            <p>Cargando artículos...</p>
                        ) : articles.length > 0 ? (
                            <>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Cantidad</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {articles.map((article) => (
                                            <tr key={article.article_id}>
                                                <td>{article.name_es}</td>
                                                <td>{article.total_quantity || 0} unidades</td>
                                                <td>
                                                    <button
                                                        className="eye-button"
                                                        onClick={() => goToLogs(article)}
                                                    >
                                                     <i class="fa fa-chevron-circle-right fa-1x"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="pagination">
                                    <button
                                        className="pagination-button"
                                        onClick={() => setPage(page - 1)}
                                        disabled={page === 1}
                                    >
                                        Anterior
                                    </button>
                                    {[...Array(totalPages).keys()].map((num) => (
                                        <button
                                            key={num}
                                            className={`pagination-button ${page === num + 1 ? 'active' : ''}`}
                                            onClick={() => setPage(num + 1)}
                                        >
                                            {num + 1}
                                        </button>
                                    ))}
                                    <button
                                        className="pagination-button"
                                        onClick={() => setPage(page + 1)}
                                        disabled={page === totalPages}
                                    >
                                        Siguiente
                                    </button>
                                </div>
                            </>
                        ) : (
                            <p>No se encontraron artículos.</p>
                        )}
                    </div>
                </>
            )}
            {view === 'logs' && (
                <div className="logs-section">
                    <button className="back-button" onClick={goToArticles}>
                        ⬅️ Volver
                    </button>
                    <h2>Logs para: {selectedArticle?.name_es}</h2>
                    {logsLoading ? (
                        <p>Cargando logs...</p>
                    ) : logs.length > 0 ? (
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Palet</th>
                                    <th>Cantidad</th>
                                    <th>Empleado</th>
                                    <th>Fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map((log, index) => (
                                    <tr key={index}>
                                        <td>{log.name_es}</td>
                                        <td>{log.palet}</td>
                                        <td>{log.cantidad}</td>
                                        <td>{log.employee}</td>
                                        <td>{new Date(log.date).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p>No se encontraron logs.</p>
                    )}
                </div>
            )}
        </div>
    );
};
const StockSearchPla = () => {
    const [articles, setArticles] = useState([]);
    const [logs, setLogs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [logsLoading, setLogsLoading] = useState(false);
    const [view, setView] = useState('articles'); // 'articles' para la lista de artículos, 'logs' para la vista de logs
    const [selectedArticle, setSelectedArticle] = useState(null);

    // Fetch para los artículos con paginación
    const fetchArticles = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `http://localhost:5000/articles-paginated?page=${page}&limit=20&name=${encodeURIComponent(searchTerm)}`
            );
            const data = await response.json();
            setArticles(data.articles);
            setTotalPages(data.pages);
        } catch (error) {
            console.error('Error al obtener artículos:', error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch para los logs de un artículo específico
    const fetchLogs = async (articleId) => {
        setLogsLoading(true);
        try {
            const response = await fetch(`http://localhost:5000/logs/${articleId}`);
            const data = await response.json();
            setLogs(data);
        } catch (error) {
            console.error('Error al obtener logs:', error);
        } finally {
            setLogsLoading(false);
        }
    };

    useEffect(() => {
        if (view === 'articles') {
            fetchArticles();
        }
    }, [page, searchTerm, view]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setPage(1); // Reiniciar a la primera página cuando se realiza una búsqueda
    };

    const goToLogs = (article) => {
        setSelectedArticle(article);
        fetchLogs(article.article_id);
        setView('logs');
    };

    const goToArticles = () => {
        setView('articles');
        setLogs([]);
        setSelectedArticle(null);
    };

    return (
        <div className="stock-search-container">
            <h1 className="title">Aielo - Gestión de Stock</h1>
            {view === 'articles' && (
                <>
                    <div className="search-bar">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Buscar artículos"
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </div>
                    <div className="articles-section">
                        {loading ? (
                            <p>Cargando artículos...</p>
                        ) : articles.length > 0 ? (
                            <>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Cantidad</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {articles.map((article) => (
                                            <tr key={article.article_id}>
                                                <td>{article.name_es}</td>
                                                <td>{article.total_quantity || 0} unidades</td>
                                                <td>
                                                    <button
                                                        className="eye-button"
                                                        onClick={() => goToLogs(article)}
                                                    >
                                                    Ver Produccion
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="pagination">
                                    <button
                                        className="pagination-button"
                                        onClick={() => setPage(page - 1)}
                                        disabled={page === 1}
                                    >
                                        Anterior
                                    </button>
                                    {[...Array(totalPages).keys()].map((num) => (
                                        <button
                                            key={num}
                                            className={`pagination-button ${page === num + 1 ? 'active' : ''}`}
                                            onClick={() => setPage(num + 1)}
                                        >
                                            {num + 1}
                                        </button>
                                    ))}
                                    <button
                                        className="pagination-button"
                                        onClick={() => setPage(page + 1)}
                                        disabled={page === totalPages}
                                    >
                                        Siguiente
                                    </button>
                                </div>
                            </>
                        ) : (
                            <p>No se encontraron artículos.</p>
                        )}
                    </div>
                </>
            )}
            {view === 'logs' && (
                <div className="logs-section">
                    <button className="back-button" onClick={goToArticles}>
                        ⬅️ Volver
                    </button>
                    <h2>Logs para: {selectedArticle?.name_es}</h2>
                    {logsLoading ? (
                        <p>Cargando logs...</p>
                    ) : logs.length > 0 ? (
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Palet</th>
                                    <th>Cantidad</th>
                                    <th>Empleado</th>
                                    <th>Fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map((log, index) => (
                                    <tr key={index}>
                                        <td>{log.name_es}</td>
                                        <td>{log.palet}</td>
                                        <td>{log.cantidad}</td>
                                        <td>{log.employee}</td>
                                        <td>{new Date(log.date).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p>No se encontraron logs.</p>
                    )}
                </div>
            )}
        </div>
    );
};
const StockSearchFil = () => {
    const [articles, setArticles] = useState([]);
    const [logs, setLogs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [logsLoading, setLogsLoading] = useState(false);
    const [view, setView] = useState('articles'); // 'articles' para la lista de artículos, 'logs' para la vista de logs
    const [selectedArticle, setSelectedArticle] = useState(null);

    // Fetch para los artículos con paginación
    const fetchArticles = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `http://localhost:5000/articles-paginated?page=${page}&limit=20&name=${encodeURIComponent(searchTerm)}`
            );
            const data = await response.json();
            setArticles(data.articles);
            setTotalPages(data.pages);
        } catch (error) {
            console.error('Error al obtener artículos:', error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch para los logs de un artículo específico
    const fetchLogs = async (articleId) => {
        setLogsLoading(true);
        try {
            const response = await fetch(`http://localhost:5000/logs/${articleId}`);
            const data = await response.json();
            setLogs(data);
        } catch (error) {
            console.error('Error al obtener logs:', error);
        } finally {
            setLogsLoading(false);
        }
    };

    useEffect(() => {
        if (view === 'articles') {
            fetchArticles();
        }
    }, [page, searchTerm, view]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setPage(1); // Reiniciar a la primera página cuando se realiza una búsqueda
    };

    const goToLogs = (article) => {
        setSelectedArticle(article);
        fetchLogs(article.article_id);
        setView('logs');
    };

    const goToArticles = () => {
        setView('articles');
        setLogs([]);
        setSelectedArticle(null);
    };

    return (
        <div className="stock-search-container">
            <h1 className="title">Aielo - Gestión de Stock</h1>
            {view === 'articles' && (
                <>
                    <div className="search-bar">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Buscar artículos"
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </div>
                    <div className="articles-section">
                        {loading ? (
                            <p>Cargando artículos...</p>
                        ) : articles.length > 0 ? (
                            <>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Cantidad</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {articles.map((article) => (
                                            <tr key={article.article_id}>
                                                <td>{article.name_es}</td>
                                                <td>{article.total_quantity || 0} unidades</td>
                                                <td>
                                                    <button
                                                        className="eye-button"
                                                        onClick={() => goToLogs(article)}
                                                    >
                                                    Ver Produccion
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="pagination">
                                    <button
                                        className="pagination-button"
                                        onClick={() => setPage(page - 1)}
                                        disabled={page === 1}
                                    >
                                        Anterior
                                    </button>
                                    {[...Array(totalPages).keys()].map((num) => (
                                        <button
                                            key={num}
                                            className={`pagination-button ${page === num + 1 ? 'active' : ''}`}
                                            onClick={() => setPage(num + 1)}
                                        >
                                            {num + 1}
                                        </button>
                                    ))}
                                    <button
                                        className="pagination-button"
                                        onClick={() => setPage(page + 1)}
                                        disabled={page === totalPages}
                                    >
                                        Siguiente
                                    </button>
                                </div>
                            </>
                        ) : (
                            <p>No se encontraron artículos.</p>
                        )}
                    </div>
                </>
            )}
            {view === 'logs' && (
                <div className="logs-section">
                    <button className="back-button" onClick={goToArticles}>
                        ⬅️ Volver
                    </button>
                    <h2>Logs para: {selectedArticle?.name_es}</h2>
                    {logsLoading ? (
                        <p>Cargando logs...</p>
                    ) : logs.length > 0 ? (
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Palet</th>
                                    <th>Cantidad</th>
                                    <th>Empleado</th>
                                    <th>Fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map((log, index) => (
                                    <tr key={index}>
                                        <td>{log.name_es}</td>
                                        <td>{log.palet}</td>
                                        <td>{log.cantidad}</td>
                                        <td>{log.employee}</td>
                                        <td>{new Date(log.date).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p>No se encontraron logs.</p>
                    )}
                </div>
            )}
        </div>
    );
};
export {StockSearchPla,StockSearch,StockSearchFil} ;
